import { createAction } from '@reduxjs/toolkit'

import { TAccountRoleApi } from 'types/GlobalAccount'

// tryGetAllUserRoles
export const getAll = createAction('get_all_account_roles')
export const getAllSuccess = createAction<{ data: TAccountRoleApi[] }>(
  'get_all_account_roles_success'
)
export const getAllFailed = createAction('get_all_account_roles_failed')
